import SubmitResponseTypes from '../../SubmitResponseTypes';
import ExternalHpaRedirectResponseHandler from './ExternalHpaRedirectResponseHandler';
import ErrorResponseHandler from './ErrorResponseHandler';
import ModalResponseHandler from './ModalResponseHandler';
import FormValidationErrorResponseHandler from './FormValidationErrorResponseHandler';
import ClientRedirectResponseHandler from './ClientRedirectResponseHandler';

/** @typedef {import("../../types").SubmitResponse} SubmitResponse */


class ResponseHandlerRetriever {
  constructor(fieldValidationProvider) {
    this.fieldValidationProvider = fieldValidationProvider;
  }

  /**
   * @param {SubmitResponse} param0
   */
  get({ type }) {
    switch (type) {
      case SubmitResponseTypes.ExternalHpaRedirectResponse:
        return ExternalHpaRedirectResponseHandler;

      case SubmitResponseTypes.Error:
        return ErrorResponseHandler;

      case SubmitResponseTypes.FormValidationError:
        return FormValidationErrorResponseHandler(this.fieldValidationProvider);

      case SubmitResponseTypes.LoadModal:
        return ModalResponseHandler;

      case SubmitResponseTypes.ClientRedirect:
        return ClientRedirectResponseHandler;

      default:
        throw new Error();
    }
  }
}

export default ResponseHandlerRetriever;



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/responseHandlers/ResponseHandlerRetriever.js